import React, {FC} from 'react';
import styled from 'styled-components';

import {ExtractProps} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {AsyncLoader} from '../loaders/asyncLoader';

/*
 * Props.
 */

type AsyncLoaderProps = ExtractProps<typeof AsyncLoader>;
interface DropdownLoaderPublicProps {
  className?: string;
}
type DropdownLoaderProps = AsyncLoaderProps & DropdownLoaderPublicProps;

/*
 * Style.
 */

const StyledLoaderDiv = styled.div`
  padding: 20px;
`;

/*
 * Component.
 */

export const DropdownLoader: FC<DropdownLoaderProps> = (props) => (
  <StyledLoaderDiv className={props.className}>
    <AsyncLoader size={VisualSizesEnum.MEDIUM} {...props} />
  </StyledLoaderDiv>
);
